module.exports = __webpack_public_path__ + "img/5.06.thmb.33731046.jpg";